import { MDCTextField } from "@material/textfield";
import $ from "jquery";
import zxcvbn from "zxcvbn";

export class Site {
    constructor() {
        jQuery(() => {
            $(".mdc-text-field").each((index, element) => {
                const textField = new MDCTextField(element);
            });

            const inputElements = document.querySelectorAll("input");
            this.checkInputsForErrorsOnPageReload(inputElements);
            this.checkPasswordStrength();
            this.togglePasswordVisibility();
            this.initializePasswordValidations();
        });
    }

    private initializePasswordValidations() {
        $(".password-field.validation").on("input", () => {
            this.validatePasswords();
        });

        $("#registerBtn,#newPasswordBtn").on("click", (event) => {
            if (!this.validatePasswords()) {
                event.preventDefault();
            }
        });
    }

    private togglePasswordValidator(result: RegExpMatchArray | boolean, element: string): void {
        if (result) {
            $(element).removeClass("fa-times").addClass("fa-check");
        }
        else {
            $(element).removeClass("fa-check").addClass("fa-times");
        }
    }

    private validatePasswords(): boolean {
        const password1 = $("#password-field1").val().toString();
        const password2 = $("#password-field2").val().toString();

        this.togglePasswordValidator(password1.match(/.{6,}/g), ".password-validation-length");
        this.togglePasswordValidator(password1.match(/[a-z]+/g), ".password-validation-lower");
        this.togglePasswordValidator(password1.match(/[A-Z]+/g), ".password-validation-upper");
        this.togglePasswordValidator(password1.match(/[0-9]+/g), ".password-validation-number");
        this.togglePasswordValidator(password1.match(/[^A-Za-z0-9]+/g), ".password-validation-special");
        this.togglePasswordValidator(password1 !== "" && password2 !== "" && password1 === password2, ".password-validation-match");

        return $(".fa-times").length === 0;
    }

    private checkInputsForErrorsOnPageReload(inputElements: NodeListOf<HTMLInputElement>) {
        Array.from(inputElements).forEach((inputElement) => {
            if (inputElement.classList.contains("input-validation-error")) {
                inputElement.parentElement.classList.add("placeholder-error");
            }
        });
    }

    private checkPasswordStrength() {
        const elements = document.getElementsByClassName("password-field");

        if (elements.length > 0) {
            const password = elements[0] as HTMLInputElement;
            const meter = document.getElementById("password-strength-meter") as HTMLMeterElement;

            if (password !== null && meter !== null) {
                password.addEventListener("input", () => {
                    const val = password.value;
                    const result = zxcvbn(val);

                    // Update the password strength meter
                    meter.value = result.score;

                    // Update the text indicator
                    // 0 worst 1 bad 2 weak 3 good 4 strong
                    for (let i = 0; i <= 4; i++) {
                        const indicator = document.getElementById(`password-strength-${i}`);
                        indicator.hidden = result.score !== i;
                    }
                });
            }
        }
    }

    private togglePasswordVisibility() {
        $(".view-password").on("click", () => {
            let passwords = $(".password-field");
            for (let i = 0; i < passwords.length; i++) {
                if (passwords[i].getAttribute("type") === "password") {
                    passwords[i].setAttribute("type", "text");
                    $(passwords[i]).siblings("span").children("i").removeClass("fa-eye").addClass("fa-eye-slash");
                }
                else {
                    passwords[i].setAttribute("type", "password");
                    $(passwords[i]).siblings("span").children("i").removeClass("fa-eye-slash").addClass("fa-eye");
                }
            }
        });
    }
}

// needed on all pages
if (/\/?$/i.test(location.pathname)) {
    const siteWindow = window as any;
    siteWindow.site = new Site();
}
